import React from "react";
import PropTypes from "prop-types";
import truncate from "lodash/truncate";

function stripHtml(text) {
    return text.replace(/<[^>]+>/g, " ");
}

function truncateText(text, length) {
    return truncate(text, {length, omission: "..."});
}

const BlogPostTextPreview = ({body, length = 200, ...props}) => {
    return (
        <span
            style={{
                wordBreak: "break-word",
                hyphens: "auto",
                color: `${props?.color}`,
            }}
        >
            {truncateText(stripHtml(body), length)}
        </span>
    );
};

BlogPostTextPreview.propTypes = {
    body: PropTypes.string,
};

BlogPostTextPreview.defaultProps = {
    body: "",
};
export default BlogPostTextPreview;
